<div class="uilab-card uilab-card--static">
  <div class="uilab-card--content">
    <header class="uilab-card--header">
      <h4>{{ card.title }}</h4>
    </header>

    <p [innerHTML]="card.summary"></p>

    @if (card.date) {
      <article class="uilab-card--article">
        <strong>Date:</strong> {{ card.date | date: 'mediumDate' }}
      </article>
    }

    @if (card.product?.joined) {
      <article class="uilab-card--article">
        <strong>Product:</strong> {{ card.product?.joined }}
      </article>
    }

    @if (card.type) {
      <article class="uilab-card--article">
        <strong>Research type:</strong> {{ card.type.joined }}
      </article>
    }

    @if (card.researchers) {
      <article class="uilab-card--article">
        <strong>Researchers:</strong> {{ card.researchers }}
      </article>
    }

    <footer>
      <p>
        @if (card.studyReportLink) {
          <a
            [href]="card.studyReportLink"
            target="_blank"
            >
            Study report
          </a>
        }

        @if (card.meetingReportLink) {
          <a
            [href]="card.meetingReportLink"
            target="_blank"
            >
            Meeting report back
          </a>
        }

        @if (card.prototypeLink) {
          <a
            [href]="card.prototypeLink"
            target="_blank"
            >
            Prototype
          </a>
        }
      </p>
    </footer>
  </div>
</div>
